module.exports = __webpack_public_path__ + "static/media/management-portals.f6e20b44.svg";